import dayjs from 'dayjs';

// Number formatting
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  
  return num.toString();
};

// Date formatting
export const formatDate = (date, format = 'MMM DD, YYYY') => {
  if (!date) return 'N/A';
  
  try {
    // Handle date strings that might be interpreted as UTC
    // If it's a date string in YYYY-MM-DD format, treat it as local time
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return dayjs(date + 'T00:00:00').format(format);
    }
    return dayjs(date).format(format);
  } catch (error) {
    return 'Invalid Date';
  }
};

// Date and time formatting
export const formatDateTime = (date) => {
  return formatDate(date, 'MMM DD, YYYY HH:mm');
};

// Relative time formatting
export const formatRelativeTime = (date) => {
  if (!date) return 'N/A';
  
  try {
    const now = dayjs();
    const target = dayjs(date);
    const diff = now.diff(target, 'day');
    
    if (diff === 0) {
      return 'Today';
    } else if (diff === 1) {
      return 'Yesterday';
    } else if (diff > 1 && diff <= 7) {
      return `${diff} days ago`;
    } else {
      return formatDate(date);
    }
  } catch (error) {
    return 'Invalid Date';
  }
};

// Currency formatting
export const formatCurrency = (amount, currency = 'INR') => {
  if (amount === null || amount === undefined) return '₹0';
  
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

// Percentage formatting
export const formatPercentage = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  
  return `${value.toFixed(decimals)}%`;
};

// File size formatting
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Status formatting
export const formatStatus = (status) => {
  const statusMap = {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    overdue: 'Overdue',
    draft: 'Draft',
    published: 'Published',
    acknowledged: 'Acknowledged',
  };
  
  return statusMap[status] || status;
};

// Phone number formatting
export const formatPhoneNumber = (phone) => {
  if (!phone) return 'N/A';
  
  // Remove all non-digits
  const cleaned = phone.replace(/\D/g, '');
  
  // Format Indian phone numbers
  if (cleaned.length === 10) {
    return `+91 ${cleaned.slice(0, 5)} ${cleaned.slice(5)}`;
  } else if (cleaned.length === 12 && cleaned.startsWith('91')) {
    return `+91 ${cleaned.slice(2, 7)} ${cleaned.slice(7)}`;
  }
  
  return phone;
};
